import { CommonModule, DOCUMENT } from '@angular/common';
import { ModuleWithProviders, APP_INITIALIZER, NgModule, NgZone } from '@angular/core';
import { BkkrConfig } from '@bkkr/core';

import { appInit } from './app-init';
import { BooleanValueAccessorDirective } from './directives/control-value-accessors/boolean-value-accessor';
import { NumericValueAccessorDirective } from './directives/control-value-accessors/numeric-value-accesssor';
import { RadioValueAccessorDirective } from './directives/control-value-accessors/radio-value-accessor';
import { SelectValueAccessorDirective } from './directives/control-value-accessors/select-value-accessor';
import { TextValueAccessorDirective } from './directives/control-value-accessors/text-value-accessor';
import { NavDelegate } from './directives/navigation/nav-delegate';
import {
  RouterLinkDelegateDirective,
  RouterLinkWithHrefDelegateDirective,
} from './directives/navigation/router-link-delegate';
import { BkkrRouterOutlet } from './directives/navigation/router-outlet';
import { BkkrTabs } from './directives/navigation/tabs';
import { BkkrDrawer } from './directives/overlays/drawer';
import { BkkrModal } from './directives/overlays/modal';
import { BkkrPopover } from './directives/overlays/popover';
import {
  BkkrAccordion,
  BkkrAccordionGroup,
  BkkrBackdrop,
  BkkrBadge,
  BkkrBreadcrumb,
  BkkrBreadcrumbs,
  BkkrButton,
  BkkrCard,
  BkkrCardContent,
  BkkrCardHeader,
  BkkrCheckbox,
  BkkrCol,
  BkkrContainer,
  BkkrContent,
  BkkrDatetime,
  BkkrFab,
  BkkrFabButton,
  BkkrFooter,
  BkkrGrid,
  BkkrHeader,
  BkkrIcon,
  BkkrImg,
  BkkrInfiniteScroll,
  BkkrInput,
  BkkrItem,
  BkkrLabel,
  BkkrList,
  BkkrListHeader,
  BkkrMenu,
  BkkrMenuToggle,
  BkkrNav,
  BkkrNavs,
  BkkrNote,
  BkkrPaginator,
  BkkrProgressBar,
  BkkrRadio,
  BkkrRadioGroup,
  BkkrRange,
  BkkrReorder,
  BkkrReorderGroup,
  BkkrRoot,
  BkkrRow,
  BkkrSearchbar,
  BkkrSegment,
  BkkrSegmentButton,
  BkkrSelect,
  BkkrSelectOption,
  BkkrShape,
  BkkrSkeleton,
  BkkrSlide,
  BkkrSlides,
  BkkrSpinner,
  BkkrSplitPane,
  BkkrTextarea,
  BkkrThumbnail,
  BkkrToggle,
  BkkrToolbar,
} from './directives/proxies';
import { AngularDelegate } from './providers/angular-delegate';
import { ConfigToken } from './providers/config';
import { DrawerController } from './providers/drawer-controller';
import { ModalController } from './providers/modal-controller';
import { PopoverController } from './providers/popover-controller';

const DECLARATIONS = [
  BkkrAccordion,
  BkkrAccordionGroup,
  BkkrBackdrop,
  BkkrBadge,
  BkkrBreadcrumb,
  BkkrBreadcrumbs,
  BkkrButton,
  BkkrCard,
  BkkrCardContent,
  BkkrCardHeader,
  BkkrCheckbox,
  BkkrCol,
  BkkrContainer,
  BkkrContent,
  BkkrDatetime,
  BkkrDrawer,
  BkkrFab,
  BkkrFabButton,
  BkkrFooter,
  BkkrGrid,
  BkkrHeader,
  BkkrIcon,
  BkkrImg,
  BkkrInfiniteScroll,
  BkkrInput,
  BkkrItem,
  BkkrLabel,
  BkkrList,
  BkkrListHeader,
  BkkrMenu,
  BkkrMenuToggle,
  BkkrModal,
  BkkrNav,
  BkkrNavs,
  BkkrNote,
  BkkrPaginator,
  BkkrPopover,
  BkkrProgressBar,
  BkkrRadio,
  BkkrRadioGroup,
  BkkrRange,
  BkkrReorder,
  BkkrReorderGroup,
  BkkrRoot,
  BkkrRow,
  BkkrSearchbar,
  BkkrSegment,
  BkkrSegmentButton,
  BkkrSelect,
  BkkrSelectOption,
  BkkrShape,
  BkkrSkeleton,
  BkkrSlide,
  BkkrSlides,
  BkkrSpinner,
  BkkrSplitPane,
  BkkrTextarea,
  BkkrThumbnail,
  BkkrToggle,
  BkkrToolbar,

  BkkrTabs,

  // ngModel accessors
  BooleanValueAccessorDirective,
  NumericValueAccessorDirective,
  RadioValueAccessorDirective,
  SelectValueAccessorDirective,
  TextValueAccessorDirective,

  // navigation
  BkkrRouterOutlet,
  NavDelegate,
  RouterLinkDelegateDirective,
  RouterLinkWithHrefDelegateDirective,
];

@NgModule({
  declarations: DECLARATIONS,
  exports: DECLARATIONS,
  providers: [AngularDelegate, DrawerController, ModalController, PopoverController],
  imports: [CommonModule],
})
export class BkkrModule {
  static forRoot(config?: BkkrConfig): ModuleWithProviders<BkkrModule> {
    return {
      ngModule: BkkrModule,
      providers: [
        {
          provide: ConfigToken,
          useValue: config,
        },
        {
          provide: APP_INITIALIZER,
          useFactory: appInit,
          multi: true,
          deps: [ConfigToken, DOCUMENT, NgZone],
        },
      ],
    };
  }
}
